
export class SessionStorageProvider implements ISessionStorageProvider
{
    public clear(): void
    {
        sessionStorage.clear();
    }
}

export interface ISessionStorageProvider
{
    clear(): void;
}
